<template>
  <div class="data-list-container">
    <vs-row vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-xs="12"
      >
        <vx-card title="Lead">
          <div style="word-break: break-all;">
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-align="center"
                vs-lg="3"
                vs-md="3"
                vs-xs="12"
              >
              <profile-image :image="leadDetails" @changingImage="ImageChanged"/>
              </vs-col>
              <vs-col
                vs-lg="9"
                vs-md="9"
                vs-xs="12"
                class="pl-2"
              >
              <vs-row>
                <h3 style="font-weight:bold;" class="text-primary">{{ leadDetails.lead_first_name }} {{ leadDetails.lead_last_name }}</h3>
              </vs-row>
                <vs-row class="mt-2">
                  <vs-icon icon-pack="feather" color="primary" icon="icon-mail" class="account-icon" />
                  <h5 class="ml-2">{{ leadDetails.email }}</h5>
                </vs-row>
                <vs-row class="mt-2">
                  <vs-icon icon-pack="feather" color="primary" icon="icon-map-pin" class="account-icon" />
                    <h6 v-if="leadDetails.lead_city !=='' ||  leadDetails.lead_state !=='' " class="pl-2" style="word-break:break-word;">
                      <span v-if="leadDetails.lead_city!==''" style="word-break:break-word;">
                        {{ leadDetails.lead_city }},
                      </span>
                      <span v-if="leadDetails.lead_state !==''" style="word-break:break-word;">
                        {{ leadDetails.lead_state }},
                      </span>
                      <span v-if="leadDetails.platform_customer_countries_id !==''" style="word-break:break-word;">
                        {{ getcountry(leadDetails.platform_customer_countries_id) }}
                      </span>
                    </h6>
                    <h6 v-else>
                      Unavailable
                    </h6>
                </vs-row>
                <vs-row class="mt-2">
                  <a :href="leadDetails.lead_facebook" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-facebook" class="mr-3 account-icon"/>
                  </a>
                  <a :href="leadDetails.lead_twitter" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-twitter" class="mr-3 account-icon"/>
                  </a>
                  <!-- <a :href="leadDetails.social_media.instagram" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-instagram" class="mr-3 account-icon"/>
                  </a> -->
                  <a :href="leadDetails.lead_linkedin" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-linkedin" class="mr-3 account-icon"/>
                  </a>
                  <a :href="leadDetails.lead_website" target="_blank">
                    <vs-icon icon-pack="feather" icon="icon-quora" class="mr-3 account-icon"/>
                  </a>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vx-card>
      </vs-col>
   <vs-col vs-lg="8" vs-xs="12" class="p-3">
        <vs-row vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="70K"
              statisticTitle="Orders Received"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="70K"
              statisticTitle="Date Added"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="12"
              statisticTitle="Status"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="1K"
              statisticTitle="Overdue Invoice"
              color="danger"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="42"
              statisticTitle="New Lead"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="DollarSignIcon"
              class="m-1"
              statistic="20"
              statisticTitle="New Lead"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="CalenderIcon"
              class="m-1"
              statistic="10"
              statisticTitle="New Lead"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="UsersIcon"
              class="m-1"
              statistic="50"
              statisticTitle="New Lead"
              color="danger"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="UserIcon"
              class="m-1"
              statistic="100"
              statisticTitle="New Lead"
              color="success"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="UsersIcon"
              class="m-1"
              statistic="20"
              statisticTitle="New Lead"
              color="danger"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="UsersIcon"
              class="m-1"
              statistic="20"
              statisticTitle="New Lead"
              color="primary"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-xs="12"
          >
            <statistics-card-line-no-chart
              hideChart
              icon="UsersIcon"
              class="m-1"
              statistic="20"
              statisticTitle="New Lead"
              color="warning"
              type="area"
            ></statistics-card-line-no-chart>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
      <!-- <pre>{{leadDetails}}</pre> -->
   <vx-card v-if="!visible" title="Basic Details">
      <div class="flex" vs-align="flex-end" style="float:right;margin-top: -5.2%;">
        <vs-button
          radius
          icon="edit"
          color="primary"
          class="mr-2"
          vs-type="flex"
          @click="visible=!visible"
        />
      </div>
      <vs-row vs-w="12" class="m-3">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="6">
          <b>First Name</b>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="6">
          {{ leadDetails.lead_first_name }}
        </vs-col>
         <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Middle Name</b>
        </vs-col>
      
    <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_middle_name }}
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Last Name</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_last_name }}
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Phone Number</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.phone }}
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Email</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.email }}
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Address Line 1</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_address1 }}
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Address Line 2</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_address2 }}
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>City</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_city }}
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Zip Code</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_zip }}
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>State</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          {{ leadDetails.lead_state }}
        </vs-col>
            <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <b>Country</b>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
        {{ leadDetails.country_details!= null?leadDetails.country_details.country_name:'' }}
        </vs-col>
        </vs-row>
   </vx-card>
   <vx-card v-if="visible" class="mt-3">
      <vx-card title="Basic Details" class="mt-3">
         <form data-vv-scope="add">
        <div class="vx-row">
          
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="4" :vs-lg="4" class="p-2"  v-for="childfield in staticChildFields"
            :key="childfield.id">
             <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id'"
              v-model="leadDetails[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              
            />

            <v-select
              v-else
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="leadDetails[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              :reduce="(option) => option.id"
              label="country_name"
              :options="countryList"
              style="width: 100%"
              
            />
            
            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="childfield.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>

            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
             
            </vs-col>
           
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="{url: {require_protocol: true }}" name="facebook" v-model="leadDetails.lead_facebook" class="custom_Input" label="Facebook" icon-pack="feather" icon="icon-facebook" icon-before placeholder="facebook" style="width:100%;" vs-placeholder="facebook" />
            <span v-show="errors.has('add.facebook')" class="text-danger">{{ errors.first('add.facebook') }}</span>
          </vs-col>
          <!-- <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="{url: {require_protocol: true }}" v-model="leadDetails.social_media.instagram" name="instagram" class="custom_Input" label="Instagram" icon-pack="feather" icon="icon-instagram" icon-before placeholder="instagram" style="width:100%;" vs-placeholder="instagram"/>
            <span v-show="errors.has('add.instagram')" class="text-danger">{{ errors.first('add.instagram') }}</span>
          </vs-col> -->
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="{url: {require_protocol: true }}" name="twitter" v-model="leadDetails.lead_twitter" label="Twitter" icon-pack="feather" icon="icon-twitter" icon-before placeholder="twitter" style="width:100%;" vs-placeholder="twitter"/>
            <span v-show="errors.has('add.twitter')" class="text-danger">{{ errors.first('add.twitter') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="{url: {require_protocol: true }}" name="linkedin" v-model="leadDetails.lead_linkedin" class="custom_Input" label="Linkedin" icon-pack="feather" icon="icon-linkedin" icon-before placeholder="linkedin" style="width:100%;" vs-placeholder="linkedin"/>
            <span v-show="errors.has('add.linkedin')" class="text-danger">{{ errors.first('add.linkedin') }}</span>
          </vs-col>
          <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="{url: {require_protocol: true }}" name="quara" v-model="leadDetails.lead_website" class="custom_Input" label="Quara" icon-pack="feather" icon="icon-quara" icon-before placeholder="quara" style="width:100%;" vs-placeholder="quara"/>
            <span v-show="errors.has('add.quara')" class="text-danger">{{ errors.first('add.quara') }}</span>
          </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
            <vs-button class="mr-2"  @click.prevent="UpdateDetails">Update</vs-button>
            <vs-button type="border" color="danger" @click="visible = false">Cancel</vs-button>
          </vs-row>
        </div>
         </form>
      </vx-card>
    </vx-card>
  </div>
</template>
<script>
import { fetchCustomStaticFields } from '@/api/customfield'
import StatisticsCardLineNoChart from './cards.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { GetCountryList } from '@/api/common'
import { leadDetailsApi } from '@/api/leaddetails'
import { update_lead_list, updateMinor } from '@/api/leads'
import vSelect from 'vue-select'
import phone from '@/components/teachers/phone.vue'
import email from '@/components/teachers/email.vue'
import addressDetails from '@/components/teachers/address.vue'
import availabilityDetails from '@/components/teachers/availablity.vue'
import award from '@/components/teachers/award.vue'
import holiday from '@/views/pages/v1/user_profile/components/availability/holidays.vue'
import education from '@/components/teachers/educations.vue'
import language from '@/components/teachers/language.vue'
import socialLink from '@/components/clients/socialLinks'
import clientAddress from '@/components/clients/address'
import minors from '@/components/clients/minors'
import profileImage from '@/components/imageUpload/imageUploadAndShow'
export default {
  components: {
    StatisticsCardLineNoChart,
    flatPickr,
    vSelect,
    phone,
    email,
    addressDetails,
    availabilityDetails,
    award,
    holiday,
    education,
    language,
    socialLink,
    clientAddress,
    minors,
    profileImage
  },
  data () {
    return {
      staticChildFields: [],
      cardTitle:'Other-Contacts',
      visible:false,
      leadDetails: {},
      basic_details: {},
      configdateTimePicker: {
        enableTime: false,
        enableSeconds: true,
        noCalendar: false
      },
      permissions:[],
      leads_id:'',
      countryList:null,
      users:[],
      genderList: [
        {
          label:'Male',
          value:'MALE'
        },
        {
          label:'Female',
          value:'FEMALE'
        }
      ]
    }
  },
  mounted () {
    this.leads_id = this.$route.params.lead_user_id
   
    this.fetchLeadAccountDetails(this.leads_id)
    this.fetchCountry()
    this.fetch_field_list()
  },
  methods: {
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(1, customerId)
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {}
    },
    async ImageChanged (imageUrl) {
      // 
      try {
        const payload = {
          updateField:{
            picture: imageUrl,
            first_name: this.leadDetails.lead_first_name,
            middle_name: this.leadDetails.middle_name,
            last_name:this.leadDetails.last_name,
            email:this.leadDetails.email,
            mobile: this.leadDetails.mobile,
            address: this.leadDetails.address,
            bio:this.leadDetails.bio,
            social_media:this.leadDetails.social_media
          }
        }
        const { data } = await update_lead_list(this.$route.params.leads_user_id, payload)
        this.leadDetails = data.data.minor_details
        
        this.visible = false
        this.$vs.notify({
          title: 'Updated',
          text: 'Child Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        
      } catch (e) {
        
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    handleAccountEdit () {
      this.accountEdit = true
    },
    async fetchCountry () {
      try {
        const {data} = await GetCountryList()
        this.countryList = data.data.countries_list
        
      } catch (e) {
        
      }
    },
    async fetchLeadAccountDetails (lead_id) {
      try {
        const { data } = await leadDetailsApi(lead_id,this.$store.getters.customerId)
        this.leadDetails = data.data.leads_details
      } catch (e) {
        
      }
    },
    async UpdateDetails () {
      try {
         const validateParent =await  this.$validator.validateAll('add')
      // const childDynamicComponent =
      //   this.$refs.children.$validator.validateAll('add')
      const validateAll = await Promise.all([validateParent])
console.log(validateAll)
      if(!validateAll.includes(false)){

const payload = {
          leads_id:this.leads_id,
          parent_leads_id:this.leadDetails.root_user,
          updated_field:{
            lead_first_name: this.leadDetails.lead_first_name,
            lead_middle_name: this.leadDetails.lead_middle_name,
            lead_last_name:this.leadDetails.lead_last_name,
            email:this.leadDetails.email,
            phone: this.leadDetails.phone,
            lead_address1: this.leadDetails.lead_address1,
            lead_address2: this.leadDetails.lead_address2,
            lead_city: this.leadDetails.lead_city,
            lead_state: this.leadDetails.lead_state,
            lead_zip: this.leadDetails.lead_zip,
            platform_customer_countries_id:this.leadDetails.platform_customer_countries_id,
            social_media:this.leadDetails.social_media
          }
        }
          const { data } = await updateMinor(payload, this.$store.getters.customerId)
        this.leadDetails = data.data.minor_details
        
        this.visible = false
        this.$vs.notify({
          title: 'Updated',
          text: 'Child Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
} else{
 this.$vs.notify({
            title: 'Warning',
            text: 'All validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
}
      
      } catch (e) {
        
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    havePermission (module) {
      const modules = this.permissions
      for (const item of modules) {
        if (item.sub_module_table === module) {
          if (item.enabled === 1) {
            return true
          } else {
            return false
          }
        }
      }
    },
    handleChangePage (id) {
      

    },
    getcountry (id) {
      const countryList = this.countryList
      for (const item of countryList) {
        if (item.id === id) {
          return item.country_name
        }
      }
    }
  }
}
</script>
<style scoped>
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
.custom_Input {
  border: none !important;
  border-bottom:1px solid rgba(0, 0, 0, 0.2);
}
.socialIcon{
  font-size:30px;
}
.required:after {
  content: " *";
  color: red;
}
@media only screen and (max-width: 1336px) {
  .profile_image {
    height:75px;
    width:75px;
    border-radius: 50%;
  }
}
</style>
